import {CommonModule} from '@angular/common';
import {
	AfterContentInit,
	ChangeDetectionStrategy,
	Component,
	Input,
	NgModule,
	ViewChild,
	ViewEncapsulation
} from '@angular/core';

@Component({
	standalone: false,
	selector: '[im-since-year]',
	// keep one line for space
	template: `
		<span #yearRef><ng-content></ng-content></span><span *ngIf="currentYear">~{{currentYear}}</span>
	`,
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class: 'im-since-year'
	}
})
export class SinceYearComponent implements AfterContentInit {
	@Input('im-since-year') set fromSelector(year: number) {
		this.year = year || (new Date).getFullYear();
	}

	@ViewChild('yearRef', {static: true}) yearRef;

	year!: number;
	currentYear!: number;

	ngAfterContentInit() {
		const {yearRef} = this;
		if (this.year) {
			yearRef.nativeElement.innerHTML = this.year;
		} else {
			this.year = Number(yearRef.nativeElement.innerText);
		}

		const currentYear = (new Date).getFullYear();

		if (this.year < currentYear) {
			this.currentYear = currentYear;
		}
	}
}

@NgModule({
	declarations: [
		SinceYearComponent
	],
	imports     : [
		CommonModule
	],
	exports     : [
		SinceYearComponent
	]
})
export class SinceYearModule {
}
